import type { ItemPreVisualizacaoCsv } from '../types'

const ABREV_MES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']

/** "out/2026" */
export const mesAno = (mes?: number | null, ano?: number | null) => (mes && ano ? `${ABREV_MES[mes - 1]}/${ano}` : '')

/** Item que casou com um lançamento já existente em outra fatura e pode ser movido para o destino. */
export const podeMover = (i: ItemPreVisualizacaoCsv) => !!i.moverSugerido && !!i.transacaoExistenteId

/** Saldo do mês anterior que dá para transferir: tem fatura anterior (não paga, o servidor só devolve nesse caso) com sobra. */
export const podeTransferirSaldo = (i: ItemPreVisualizacaoCsv) =>
  !!i.saldoTransferido && !!i.faturaAnteriorId && (i.faturaAnteriorTotal ?? 0) > 0 && i.valor > 0

export type ModoSaldo = 'banco' | 'app'

/** Valor a mandar em transferirSaldo conforme a escolha. */
export const valorTransferencia = (i: ItemPreVisualizacaoCsv, modo: ModoSaldo) =>
  Math.round((modo === 'banco' ? i.valor : (i.faturaAnteriorTotal ?? 0)) * 100) / 100
